// extracted by mini-css-extract-plugin
export default {"actionArea":"Cardx_actionArea__L6247","container":"Cardx_container__dDHhA"};